import { z } from 'zod';
import { ConstraintSchema, constraintFields } from '@/lib/account-constraints';
import type { AccountConstraint } from '@/types/schemas';

// Schema for FormDialog - matches only actual form fields
const baseSchema = z.object({
  // BasicInfoTab - Customer Information (text fields)
  ma_so_thue: z.string().optional().nullable(),
  ong_ba: z.string().optional().nullable(),
  e_mail: z.string().optional().nullable(),
  dien_giai: z.string().optional().nullable(),
  ma_httt: z.string().optional().nullable(),
  pt_tao_yn: z.boolean().optional().nullable(),
  transfer_yn: z.boolean().optional().nullable(),

  // BasicInfoTab - Document Information
  ngay_ct: z.string().optional().nullable(),
  ngay_lct: z.string().optional().nullable(),
  ma_nt: z.string().optional().nullable(),
  status: z.string().optional(),

  // OtherTab Fields (all text fields)
  ly_do_huy: z.string().optional().nullable(),
  ly_do: z.string().optional().nullable(),
  ten_vt_thue: z.string().optional().nullable(),
  ghi_chu: z.string().optional().nullable(),

  // EInvoiceTab Fields (text and date fields)
  so_ct_hddt: z.string().optional().nullable(),
  ngay_ct_hddt: z.string().nullable(), // date field
  so_ct2_hddt: z.string().optional().nullable(),
  ma_mau_ct_hddt: z.string().optional().nullable(),
  ma_tt: z.string().optional().nullable(),
  ma_tthddt: z.string().optional().nullable(),
  ma_pttt: z.string().nullable(),
  chi_tiet: z
    .array(
      z.object({
        ma_dv: z.string().optional().nullable(),
        tk_dt: z.string().optional().nullable(),
        so_luong: z.coerce.number().optional().nullable(),
        ...constraintFields
      })
    )
    .optional()
});

export const formSchema = (constraints: AccountConstraint[] = []) => ConstraintSchema(baseSchema, constraints);

export const initialFormValues: FormValues = {
  // BasicInfoTab - Customer Information (text fields)
  ma_so_thue: '',
  ong_ba: '',
  e_mail: '',
  dien_giai: '',
  ma_httt: 'TMB',
  pt_tao_yn: false,
  transfer_yn: true,

  // BasicInfoTab - Document Information
  ngay_ct: new Date().toISOString().split('T')[0],
  ngay_lct: new Date().toISOString().split('T')[0],
  ma_nt: '',
  status: '5',

  // OtherTab Fields (all text fields)
  ly_do_huy: '',
  ly_do: '',
  ten_vt_thue: '',
  ghi_chu: '',

  // EInvoiceTab Fields (text and date fields)
  so_ct_hddt: '',
  ngay_ct_hddt: '',
  so_ct2_hddt: '',
  ma_mau_ct_hddt: '',
  ma_tt: '',
  ma_tthddt: '',
  ma_pttt: ''
};

export type FormValues = z.infer<typeof baseSchema>;

// Schema for SearchDialog
export const searchSchema = z.object({
  startDate: z.string().optional().nullable(),
  endDate: z.string().optional().nullable(),
  voucherNumberStart: z.string().optional().nullable(),
  voucherNumberEnd: z.string().optional().nullable(),
  debitAccount: z.string().optional().nullable(),
  customerCode: z.string().optional().nullable(),
  employeeCode: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  unit: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  filterByUser: z.string().optional().nullable(),
  revenueAccount: z.string().optional().nullable()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  startDate: '',
  endDate: '',
  voucherNumberStart: '',
  voucherNumberEnd: '',
  debitAccount: '',
  customerCode: '',
  employeeCode: '',
  description: '',
  unit: '',
  status: '',
  filterByUser: '',
  revenueAccount: ''
};
